<template>
    <div class="row wrapper border-bottom white-bg page-heading">
        <div class="col-lg-10">
            <h2>{{ $t("navigations.edit checks") }}</h2>
        </div>
    </div>
    <div class="wrapper wrapper-content px-0">
        <div class="ibox-content mb-1 px-3 py-2">
            <div class="form-group mb-1">
                <div class="d-flex flex-column flex-lg-row my-2 my-lg-0 mb-lg-0">
                    <div class="form-group mb-lg-0 w-100 pl-lg-0 px-1">
                        <label class="mb-0"> {{ $t("navigations.related ecrf") }}</label>
                        <input
                            type="text"
                            v-model="this.formid"
                            class="form-control my-md-2 my-lg-0"
                        />
                    </div>
                    <div class="form-group mb-lg-0 w-100 px-1">
                        <label class="mb-0"> {{ $t("navigations.category") }}</label>
                        <input
                        type="text"
                        v-model="this.category"
                        class="form-control my-md-2 my-lg-0"
                        />
                    </div>
                    <div class="form-group mb-lg-0 w-100 px-1">
                        <label class="mb-0"> {{ $t("navigations.approval status") }}</label>
                        <select class="form-select my-md-2 my-lg-0" v-model="this.approvalStatus" name="approval status">
                            <option value="">{{ $t("navigations.all") }}</option>
                            <option v-for="status in approvalStatuses" :key="status.status" :value="status.status">
                                {{ status.status }}
                            </option>
                        </select>
                    </div>
                    <span
                        @click="search()"
                        class="col-sm-12 col-lg-2 save_btn my-1 my-lg-0 mx-lg-1 align-self-end"
                    >
                        {{ $t("navigations.search") }}
                    </span>
                </div>
            </div>
        </div>
        <div class="ibox-body">
            <div class="ibox-title style_2 d-flex justify-content-between">
                <h5 class="mt-1">{{ $t("navigations.custom rule list") }}</h5>
                <div class="d-flex align-items-center">
                    <div 
                        v-if="selectedItems.size > 0"
                        class="position-relative align-self-center mr-2"
                        aria-label="Upload subject file"
                        tabindex="0"
                    >
                        <img 
                            width="17" 
                            height="17" 
                            class="cursor-pointer" 
                            src="../../assets/img/approve_selected.png"
                            alt="Approve selected"
                            @click="bulkApprove()"
                        />
                        <div class="tool-tip"> Approve Selected </div>
                    </div>
                    <div 
                        v-if="selectedItems.size > 0"
                        class="position-relative align-self-center mr-2"
                        aria-label="Upload subject file"
                        tabindex="0"
                    >
                        <img 
                            width="17" 
                            height="17" 
                            class="cursor-pointer" 
                            src="../../assets/img/remove_selected.png"
                            alt="Remove selected"
                            @click="bulkRemove()"
                        />
                        <div class="tool-tip"> Remove Selected </div>
                    </div>
                    <div 
                    v-if="rollsprivilages.includes('Edit Checks Upload')"
                        class="position-relative align-self-center mr-2"
                        aria-label="Upload subject file"
                        tabindex="0"
                    >
                        <input class="d-none" accept=".xls,.xlsx" id="InPutFile" type="file" />
                        <img 
                            width="17" 
                            height="17" 
                            class="cursor-pointer" 
                            src="../../assets/img/upload.png"
                            alt="Upload editcheck"
                            @click.prevent="uploadEditcheckClicked()"
                        />
                        <div class="tool-tip"> Upload Editcheck </div>
                    </div>
                </div>
            </div>
            <div class="ibox-content">
                <div class="text-center" v-if="showTableLoading === true">
                    <img
                        src="../../assets/img/loading.gif"
                        width="15"
                        class=""
                        alt="Waiting for login"
                    />
                    <div>
                        {{ $t("navigations.please wait while the list is being loaded") }}
                    </div>
                </div>  
                <template v-else>   
                    <div class="text-center" v-if="customeditchecks.length==0">
                        {{ $t('navigations.no data available') }}
                    </div>  
                    <div v-else> 
                        <div class="table-responsive">
                            <table class="table table-striped table-bordered dataTables">
                                <thead>
                                    <tr>
                                        <th class="text-center" style="width: 60px;">
                                            <div class="d-flex flex-column align-items-center">
                                                <span>Select</span>
                                                <input
                                                    type="checkbox"
                                                    class="mt-1"
                                                    title="Select all"
                                                    :checked="isAllSelected"
                                                    @change="toggleSelectAll($event)"
                                                />
                                            </div>
                                        </th>

                                        <th class="sort_block" @click="SortSelected('EditCheckId', 0)" id="0">
                                            <div class="d-flex flex-row justify-content-between">
                                                {{ $t("navigations.function id") }}
                                                <span class="px-1">
                                                    <i class="fa fa-long-arrow-up"></i>
                                                    <i class="fa fa-long-arrow-down"></i>
                                                </span>
                                            </div>
                                        </th>
                                        <th class="sort_block" @click="SortSelected('Source', 1)" id="1">
                                            <div class="d-flex flex-row justify-content-between">
                                                {{ $t("navigations.function scope") }}
                                                <span class="px-1">
                                                    <i class="fa fa-long-arrow-up"></i>
                                                    <i class="fa fa-long-arrow-down"></i>
                                                </span>
                                            </div>
                                        </th>
                                        <th class="sort_block" @click="SortSelected('FormName', 2)" id="2">
                                            <div class="d-flex flex-row justify-content-between">
                                                {{ $t("navigations.related ecrf") }}
                                                <span class="px-1">
                                                    <i class="fa fa-long-arrow-up"></i>
                                                    <i class="fa fa-long-arrow-down"></i>
                                                </span>
                                            </div>
                                        </th>
                                        <th class="sort_block" @click="SortSelected('FieldName', 3)" id="3">
                                            <div class="d-flex flex-row justify-content-between">
                                                {{ $t("navigations.related field") }}
                                                <span class="px-1">
                                                    <i class="fa fa-long-arrow-up"></i>
                                                    <i class="fa fa-long-arrow-down"></i>
                                                </span>
                                            </div>
                                        </th>
                                        <th class="sort_block" @click="SortSelected('ProgramName', 4)" id="4">
                                            <div class="d-flex flex-row justify-content-between">
                                                {{ $t("navigations.program") }}
                                                <span class="px-1">
                                                    <i class="fa fa-long-arrow-up"></i>
                                                    <i class="fa fa-long-arrow-down"></i>
                                                </span>
                                            </div>
                                        </th>
                                        <th class="sort_block" @click="SortSelected('RuleVersion', 5)" id="5">
                                            <div class="d-flex flex-row justify-content-between">
                                                {{ $t("navigations.rule version") }}
                                                <span class="px-1">
                                                    <i class="fa fa-long-arrow-up"></i>
                                                    <i class="fa fa-long-arrow-down"></i>
                                                </span>
                                            </div>
                                        </th>
                                        <th class="sort_block" @click="SortSelected('Category', 6)" id="6">
                                            <div class="d-flex flex-row justify-content-between">
                                                {{ $t("navigations.category") }}
                                                <span class="px-1">
                                                    <i class="fa fa-long-arrow-up"></i>
                                                    <i class="fa fa-long-arrow-down"></i>
                                                </span>
                                            </div>
                                        </th>
                                        <th class="sort_block" @click="SortSelected('StudyVersion', 7)" id="7">
                                            <div class="d-flex flex-row justify-content-between">
                                                {{ $t("navigations.study version") }}
                                                <span class="px-1">
                                                    <i class="fa fa-long-arrow-up"></i>
                                                    <i class="fa fa-long-arrow-down"></i>
                                                </span>
                                            </div>
                                        </th>
                                        <th class="sort_block" @click="SortSelected('ApprovalStatus', 8)" id="8">
                                            <div class="d-flex flex-row justify-content-between">
                                                {{ $t("navigations.approval status") }}
                                                <span class="px-1">
                                                    <i class="fa fa-long-arrow-up"></i>
                                                    <i class="fa fa-long-arrow-down"></i>
                                                </span>
                                            </div>
                                        </th>
                                        <th>{{ $t("navigations.approved/rejected by") }}</th>
                                        <th>{{ $t("navigations.approved/rejected date") }}</th>
                                        <th class="text-center" v-if="rollsprivilages.includes('Edit Checks Actions')">{{ $t("navigations.actions") }}</th>
                                        <th class="text-center" v-if="rollsprivilages.includes('Edit Checks View')">{{ $t("navigations.view") }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in customeditchecks" :key="item.id">
                                        <td class="text-center">
                                            <input
                                                type="checkbox"
                                                :checked="selectedItems.has(item.id)"
                                                :disabled="isFinalized(item.approvalStatus)"
                                                :title="isFinalized(item.approvalStatus) ? 'Cannot select — status is ' + item.approvalStatus : ''"
                                                @change="toggleSelection(item.id)"
                                            />
                                        </td>

                                        <td> {{ item.editCheckId }}</td>
                                        <td> {{ item.scope }}</td>
                                        <td> {{ item.formName }}</td>
                                        <td> {{ item.fieldName }}</td>
                                        <td> {{ item.programName }}</td>
                                        <td> {{ item.ruleVersion }}</td>
                                        <td> {{ item.category }}</td>
                                        <td> {{ item.studyVersion }}</td>
                                        <td> {{ item.approvalStatus }}</td>
                                        <td> {{ item.approvals?.[0]?.approvedByEmail || '' }}</td>
                                        <td> {{ filter(item.approvals?.[0]?.approvedDate) }}</td>
                                        <td v-if="rollsprivilages.includes('Edit Checks Actions')" class="text-center">
                                            <i
                                                v-if="!isFinalized(item.approvalStatus)"
                                                class="fa fa-check-circle edit-delete"
                                                title="Approve / Reject"
                                                @click="openApproveRejectPopup(item)"
                                            ></i>
                                            <span
                                                v-else
                                                class="text-muted small"
                                                :title="item.approvalStatus"
                                            >—</span>
                                        </td>
                                        <td v-if="rollsprivilages.includes('Edit Checks View')" class="text-center">
                                            <i class="fa fa-eye edit-delete" @click="viewFieldRuleClicked(item)"></i>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-lg-12 mx-0 px-0">
                            <div class="dataTables_paginate paging_simple_numbers pagination float-right">
                                <div class="col-lg-12 d-flex justify-content-lg-end px-0">
                                    <v-pagination v-model="currentPage" :pages="totalPage" :range-size="1"
                                        active-color="#618bd7" @update:modelValue="loadPage" />
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
    <fieldRules
        v-if="showFieldRulePopup"
        @close-popup="showFieldRulePopup = false"
        :data="selectedFieldRuleData"
    />
    <assignRuleApprover
        v-if="showRuleApprover"
        @close-popup="documentApprovalModal = false"
    />
    <uploadEditchecks
        v-if="showUploadPopup"
        @close-popup= closeUploadPopup()
    />
    <approveRejectModal
        v-if="showApproveRejectPopup"
        heading="Approve/Reject Editcheck"
        action1Label="Approve"
        action2Label="Reject"
        httpMethod="put"
        :apiUrl="approveApiEndpoint"
        :payload="selectedEditCheckPayload"
        statusKey="status"
        commentsKey="comments"
        successMsgApprove="Editcheck approved successfully."
        successMsgReject="Editcheck rejected successfully."
        fromPage="CustomFieldRules"
        @closePopup="showApproveRejectPopup = false"
        @actionSuccess="onApproveRejectSuccess"
    />
</template>
<script src="./CustomFieldRules.js"></script>
<style scoped></style>